const defaultState = {};
export default (state = defaultState, action) => {
  switch (action.type) {
    case 'GET_NUMBERS_BY_ID':
      return defaultState;
    case 'GET_NUMBERS_BY_ID_SUCCESS':
      return { ...state, ...action.number };
    case 'ALARM_PROTOCOL_TOGGLE_SUCCESS':
      return { ...state, ...action.alarmProtocolToggle };
    case 'GET_NUMBERS_BY_ID_ERROR':
      return defaultState;
    case 'GET_NUMBER_FEATURE_BY_ID_SUCCESS':
      return { ...state, features: (action.features && action.features.tnFeature) || {} };
    default:
      return state;
  }
};
